// import { useEffect, useState } from "react";
// import FileList from "./FileList";
// import uploadApi from "../../api/uploadApi";
// import { useSelector } from "react-redux";

// const TaskUploadManager = ({ taskId='171' }) => {
//   const token = useSelector((s) => s.auth.access_token);
//   const [files, setFiles] = useState([]);
//   const [file, setFile] = useState(null);

//   const fetchFiles = async () => {
//     const res = await uploadApi.listTasksFiles(taskId,'attachments', token);
//     console.log("restsak===>",res)
//     setFiles(res);
//   };
//   useEffect(()=>{
//       fetchFiles();

//   },[]);

//   const upload = async () => {
//     const fd = new FormData();
//     fd.append("file", file);
//     await uploadApi.uploadTask(taskId, "attachments", fd, token);
//     fetchFiles();
//   };


//   return (
//     <>
//       <h3>Task Attachments</h3>
//       <input type="file" onChange={(e) => setFile(e.target.files[0])} />
//       <button onClick={upload}>Upload</button>

//       <FileList
//         files={files}
//         entityType="task"
//         entityId={taskId}
//         module="attachments"
//         token={token}
//         refresh={fetchFiles}
//       />
//     </>
//   );
// };
// export default TaskUploadManager;




import React, { useState } from "react";
import { X } from "lucide-react";
import { useSelector } from "react-redux";
import uploadApi from "../../api/uploadApi";
import { toast } from "react-toastify";

const TaskUploadManager = ({
  taskId,
  defaultModule = "attachments",
  isOpen,
  onClose,
  onUploadSuccess,
}) => {
  const token = useSelector((s) => s.auth.access_token);

  const [module, setModule] = useState(defaultModule);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const upload = async () => {
    if (!file || !taskId) return;

    try {
      setLoading(true);
      const fd = new FormData();
      fd.append("file", file);

      await uploadApi.uploadTask(taskId, module, fd, token);
      onUploadSuccess?.(); 

toast.success("Document uploaded successfully");

      setFile(null);
      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-xl shadow-xl">
        <div className="px-6 py-3 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold">Upload Document</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <select
            value={module}
            onChange={(e) => setModule(e.target.value)}
            className="border rounded-lg px-3 py-2 w-full"
          >
             <option value="attachments">Attachments</option>
            <option value="invoices">Invoices</option>
            <option value="payments">Payments</option>
            <option value="documents">Documents</option>
            <option value="reports">Reports</option>
            <option value="contracts">Contracts</option>
                        <option value="others">Others</option>

          </select>

          <input
            type="file"
            id="file"
            hidden
            onChange={(e) => setFile(e.target.files[0])}
          />

          <label
            htmlFor="file"
            className="border-2 border-dashed rounded-xl p-10 text-center cursor-pointer w-full"
          >
            {file ? file.name : "Click to select file"}
          </label>

          <button
            onClick={upload}
            disabled={!file || loading}
            className="w-full bg-primary text-white py-3 rounded-xl"
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskUploadManager;

